module.exports = __webpack_public_path__ + "img/Loose Clasp.3e35dea6.png";